/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_2_AnswerInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_2_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. In this site’s GridCraft editor, opening and saving are local file actions. Sending someone the editor link does not send them your workbook or your unsaved changes.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_2_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。本站 GridCraft 编辑器的打开与保存属于本地文件操作。把编辑器链接发给别人，并不会发送你的工作簿或尚未保存的修改。`)
};

/**
* | output |
* | --- |
* | "No. In this site’s GridCraft editor, opening and saving are local file actions. Sending someone the editor link does not send them your workbook or your unsa..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_2_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_7_questions_2_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_2_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_2_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_2_answer(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_2_answer(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_7_questions_2_answer as "gc.search_guides.gridcraft_vs_excel.sections.7.questions.2.answer" }